import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onDblclick"]
const _hoisted_2 = { class: "col-6 col-md-2 q-pr-md" }
const _hoisted_3 = { class: "images q-mb-md" }
const _hoisted_4 = {
  key: 0,
  class: "active-img-container"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "image-placeholder"
}
const _hoisted_7 = { class: "col-3 relative-position" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "col-3" }
const _hoisted_11 = {
  key: 1,
  class: "row q-col-gutter-sm"
}
const _hoisted_12 = { class: "col-3" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "col-12 col-md-6 q-px-md" }
const _hoisted_16 = { class: "title q-mb-md" }
const _hoisted_17 = {
  key: 0,
  class: "bold product-title"
}
const _hoisted_18 = { class: "description" }
const _hoisted_19 = {
  key: 0,
  class: "product-description"
}
const _hoisted_20 = { class: "col-sm-12 col-md-4" }
const _hoisted_21 = { class: "row q-mb-md" }
const _hoisted_22 = { class: "eans row" }
const _hoisted_23 = { class: "ean-value" }
const _hoisted_24 = { class: "row q-mb-md" }
const _hoisted_25 = { class: "row" }
const _hoisted_26 = { class: "row q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tooltip = _resolveComponent("tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_image_display = _resolveComponent("image-display")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_clipable = _resolveComponent("clipable")!
  const _component_barcode_icon = _resolveComponent("barcode-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_barcode = _resolveComponent("barcode")!
  const _component_form_select = _resolveComponent("form-select")!
  const _component_editable_block_input = _resolveComponent("editable-block-input")!
  const _component_q_banner = _resolveComponent("q-banner")!
  const _component_editable_block = _resolveComponent("editable-block")!

  return (_openBlock(), _createBlock(_component_editable_block, {
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitUpdate(_ctx.product.sys.id, $event))),
    onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.cancelEditing(_ctx.product))),
    "model-value": _ctx.product,
    editing: _ctx.creating,
    "remove-block-style": ""
  }, {
    default: _withCtx(({editState, editingRef}) => [
      _createElementVNode("div", {
        class: "row",
        onDblclick: ($event: any) => (editingRef.value = true)
      }, [
        (!editingRef.value)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              "tooltip-value": "Double click to edit",
              selector: ".eb-content"
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.activeImage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("img", { src: _ctx.activeImage }, null, 8, _hoisted_5)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_q_icon, {
                    class: "camera-icon",
                    name: "photo_camera",
                    size: "2rem"
                  })
                ]))
          ]),
          (editingRef.value)
            ? (_openBlock(), _createBlock(_component_draggable, _mergeProps({
                key: 0,
                class: "row q-col-gutter-sm",
                modelValue: _ctx.images,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.images) = $event)),
                handle: ".img-container"
              }, _ctx.dragOptions, {
                "item-key": "element",
                onChange: ($event: any) => (_ctx.dragImage(editState, $event))
              }), {
                item: _withCtx(({ element, index }) => [
                  _createElementVNode("div", _hoisted_7, [
                    (editingRef.value)
                      ? (_openBlock(), _createBlock(_component_q_icon, {
                          key: 0,
                          class: "remove-img",
                          name: "do_not_disturb_on",
                          onClick: ($event: any) => (_ctx.removeImage(index, editState))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (_ctx.images.length)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: _normalizeClass(["img-container", {'no-image': !_ctx.images.length, 'not-editing': !editingRef.value, active: _ctx.activeImage === element}]),
                          onClick: ($event: any) => (_ctx.setActiveImage(index))
                        }, [
                          _createElementVNode("img", { src: element }, null, 8, _hoisted_9)
                        ], 10, _hoisted_8))
                      : _createCommentVNode("", true)
                  ])
                ]),
                footer: _withCtx(() => [
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_image_display, {
                      class: "visually-hidden image-upload-product",
                      onChange: e => _ctx.fileInputHandler(e, editState),
                      accepts: ['.jpg', '.jpeg', '.png'],
                      "has-icon": "",
                      "is-image": "",
                      max: "5"
                    }, null, 8, ["onChange"]),
                    _createVNode(_component_q_icon, {
                      class: "add-image",
                      name: "add",
                      onClick: _ctx.doUploadImage
                    }, null, 8, ["onClick"])
                  ])
                ]),
                _: 2
              }, 1040, ["modelValue", "onChange"]))
            : _createCommentVNode("", true),
          (_ctx.images.length && !editingRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["img-container", {'no-image': !_ctx.images.length, 'not-editing': !editingRef.value, active: _ctx.activeImage === image}]),
                      onClick: ($event: any) => (_ctx.setActiveImage(index))
                    }, [
                      (editingRef.value)
                        ? (_openBlock(), _createBlock(_component_q_icon, {
                            key: 0,
                            name: "do_not_disturb_on",
                            onClick: ($event: any) => (_ctx.removeImage(index, editState))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      _createElementVNode("img", { src: image }, null, 8, _hoisted_14)
                    ], 10, _hoisted_13)
                  ]))
                }), 256))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            (!editingRef.value)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_17, _toDisplayString(editState.title), 1))
              : (_openBlock(), _createBlock(_component_q_input, {
                  key: 1,
                  dense: "",
                  outlined: "",
                  modelValue: editState.title,
                  "onUpdate:modelValue": ($event: any) => ((editState.title) = $event),
                  label: "Title"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          ]),
          _createElementVNode("div", _hoisted_18, [
            (!editingRef.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(editState.description), 1))
              : (_openBlock(), _createBlock(_component_q_input, {
                  key: 1,
                  dense: "",
                  outlined: "",
                  type: "textarea",
                  modelValue: editState.description,
                  "onUpdate:modelValue": ($event: any) => ((editState.description) = $event),
                  label: "Description"
                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_editable_block_input, {
              "model-value": editState.ean,
              label: "EAN",
              tooltip: _ctx.tooltips.ean
            }, {
              static: _withCtx(({ inputState }) => [
                _createElementVNode("div", _hoisted_22, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inputState.value, (value) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _createVNode(_component_clipable, {
                        payload: value,
                        message: "Copied to clipboard"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_chip, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(value), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["payload"]),
                      (!_ctx.showBarcodeEan && value)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            class: "barcode-icon q-ml-sm",
                            flat: "",
                            round: "",
                            color: "primary",
                            padding: "1px",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showBarcodeEan = true))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_barcode_icon)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (value && _ctx.showBarcodeEan)
                        ? (_openBlock(), _createBlock(_component_barcode, {
                            key: 1,
                            class: _normalizeClass(["sku-datamatrix", { active: _ctx.showBarcodeEan }]),
                            "model-value": value,
                            format: "ean13",
                            "bar-width": 15,
                            "bar-height": 3,
                            title: editState.title
                          }, null, 8, ["model-value", "title", "class"]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 256))
                ])
              ]),
              input: _withCtx(({ inputState }) => [
                _createVNode(_component_form_select, {
                  label: inputState.label,
                  modelValue: inputState.value,
                  "onUpdate:modelValue": ($event: any) => ((inputState.value) = $event),
                  type: "tag",
                  validator: e => !_ctx.validateEan(e) ? {value: false, message: 'Invalid EAN'} : _ctx.setEan(e, editState) ,
                  taggable: true,
                  placeholder: "Input EAN code(s)",
                  onClipboard: _ctx.clipped
                }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "validator", "onClipboard"])
              ]),
              _: 2
            }, 1032, ["model-value", "tooltip"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_editable_block_input, {
              modelValue: editState.sku,
              "onUpdate:modelValue": ($event: any) => ((editState.sku) = $event),
              label: "Internal reference",
              tooltip: _ctx.tooltips.sku,
              placeholder: "Generated if not set",
              max: "64",
              error: !editState.sku
            }, {
              static: _withCtx(({ inputState }) => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_clipable, {
                    payload: inputState.value,
                    message: "Copied to clipboard"
                  }, null, 8, ["payload"]),
                  (!_ctx.showBarcodeSku && inputState.value)
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        class: "barcode-icon q-ml-sm",
                        flat: "",
                        round: "",
                        color: "primary",
                        padding: "1px",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showBarcodeSku = true))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_barcode_icon)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (inputState.value && _ctx.showBarcodeSku)
                    ? (_openBlock(), _createBlock(_component_barcode, {
                        key: 1,
                        class: _normalizeClass(["sku-datamatrix", { active: _ctx.showBarcodeSku }]),
                        "model-value": inputState.value,
                        format: "datamatrixrectangular",
                        "bar-width": 15,
                        "bar-height": 3,
                        title: editState.title
                      }, null, 8, ["model-value", "title", "class"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue", "tooltip", "error"])
          ]),
          _createElementVNode("div", _hoisted_26, [
            (!editingRef.value)
              ? (_openBlock(), _createBlock(_component_editable_block_input, {
                  key: 0,
                  modelValue: editState.price,
                  "onUpdate:modelValue": ($event: any) => ((editState.price) = $event),
                  label: "Base price",
                  tooltip: _ctx.tooltips.basePrice,
                  placeholder: "0"
                }, null, 8, ["modelValue", "onUpdate:modelValue", "tooltip"]))
              : (_openBlock(), _createBlock(_component_q_input, {
                  key: 1,
                  class: "price-input",
                  modelValue: editState.price,
                  "onUpdate:modelValue": ($event: any) => ((editState.price) = $event),
                  label: "Base price",
                  placeholder: "Generated if not set",
                  max: "64",
                  type: "number",
                  mask: "#.##",
                  "fill-mask": "0",
                  "bg-color": "white",
                  "hide-bottom-space": "",
                  debounce: "100",
                  outlined: "",
                  dense: ""
                }, {
                  prepend: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("span", null, "€", -1)
                  ])),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"]))
          ])
        ]),
        (!_ctx.components?.length && !_ctx.product.components?.length)
          ? (_openBlock(), _createBlock(_component_q_banner, {
              key: 1,
              class: "rounded-borders dense text-white fit"
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("This product is in draft until you add Components. Orders referencing this product will not be accepted while it is in draft")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true)
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["model-value", "editing"]))
}